import {
  ArrowDown,
  ArrowDown10,
  ArrowDownAZ,
  ArrowUp,
  ArrowUp10,
  ArrowUpAZ,
  type LucideIcon,
} from "lucide-react";

import type { ColumnFilterType, ColumnType } from "./data-table";

interface IColumnSortInfo {
  asc: {
    text: string;
    icon: LucideIcon;
  };
  desc: {
    text: string;
    icon: LucideIcon;
  };
}
const stringSortInfo: IColumnSortInfo = {
  asc: {
    text: "A → Z",
    icon: ArrowUpAZ,
  },
  desc: {
    text: "Z → A",
    icon: ArrowDownAZ,
  },
};
const numberSortInfo: IColumnSortInfo = {
  asc: {
    text: "Low → High",
    icon: ArrowUp10,
  },
  desc: {
    text: "High → Low",
    icon: ArrowDown10,
  },
};
const dateSortInfo: IColumnSortInfo = {
  asc: {
    text: "Old → New",
    icon: ArrowUp,
  },
  desc: {
    text: "New → Old",
    icon: ArrowDown,
  },
};
const booleanSortInfo: IColumnSortInfo = {
  asc: {
    text: "False → True",
    icon: ArrowUp,
  },
  desc: {
    text: "True → False",
    icon: ArrowDown,
  },
};

export const COLUMN_SORT_INFO: Record<
  "string" | "number" | "date" | "boolean",
  IColumnSortInfo
> = {
  string: stringSortInfo,
  number: numberSortInfo,
  date: dateSortInfo,
  boolean: booleanSortInfo,
};

export const getColumnSortInfo = (
  filterType: ColumnFilterType | undefined,
  columnType: ColumnType | undefined,
): IColumnSortInfo => {
  if (!filterType && !columnType) return COLUMN_SORT_INFO.string;

  if (columnType) {
    switch (columnType) {
      case "string":
        return COLUMN_SORT_INFO.string;
      case "number":
        return COLUMN_SORT_INFO.number;
      case "date":
        return COLUMN_SORT_INFO.date;
      case "boolean":
        return COLUMN_SORT_INFO.boolean;

      default:
        return COLUMN_SORT_INFO.string;
    }
  }
  if (!filterType) return COLUMN_SORT_INFO.string;

  const filterTypeSortInfo: Record<ColumnFilterType, IColumnSortInfo> = {
    text: COLUMN_SORT_INFO.string,
    numberRange: COLUMN_SORT_INFO.number,
    date: COLUMN_SORT_INFO.date,
    creatableMultiSelect: COLUMN_SORT_INFO.string,
    multiSelect: COLUMN_SORT_INFO.string,
  };

  return filterTypeSortInfo[filterType];
};
